import { render } from "./Addrequest.vue?vue&type=template&id=38eb6ca3"
import script from "./Addrequest.vue?vue&type=script&lang=js"
export * from "./Addrequest.vue?vue&type=script&lang=js"

import "./Addrequest.vue?vue&type=style&index=0&id=38eb6ca3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__